import { BakerLoanSolutionsLogo } from '@bakerweb/components';
import { bgBlur, useOffSetTop } from '@bakerweb/theme';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { AppBar, Box, BoxProps, Button, Container, Toolbar } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export default function Header() {
  const theme = useTheme();
  const isOffset = useOffSetTop(88);

  return (
    <AppBar color="transparent" sx={{ boxShadow: 0 }}>
      <Toolbar
        disableGutters
        sx={{
          height: {
            xs: 64,
            md: 88
          },
          transition: theme.transitions.create(['height', 'background-color'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter
          }),
          ...(isOffset && {
            ...bgBlur({ color: theme.palette.background.default }),
            height: {
              md: 72
            }
          })
        }}
      >
        <Container sx={{ height: 1, display: 'flex', alignItems: 'center' }}>
          <BakerLoanSolutionsLogo sx={{ width: 190, height: 100, mt: 1, mb: 1 }} />

          <Box sx={{ flexGrow: 1 }} />
          <Button
            variant="outlined"
            endIcon={<OpenInNewIcon />}
            href="https://gobaker.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ textTransform: 'lowercase' }}
          >
            gobaker.com
          </Button>
        </Container>
      </Toolbar>

      {isOffset && <Shadow />}
    </AppBar>
  );
}

function Shadow({ sx, ...other }: BoxProps) {
  return (
    <Box
      sx={{
        left: 0,
        right: 0,
        bottom: 0,
        height: 24,
        zIndex: -1,
        m: 'auto',
        borderRadius: '50%',
        position: 'absolute',
        width: `calc(100% - 48px)`,
        boxShadow: (theme) => theme.customShadows.z8,
        ...sx
      }}
      {...other}
    />
  );
}
